import { BaseControlItem, SelectMultiple } from '@bloomfieldrobotics/canopy';
import { useMemo } from 'react';
import { Block } from '../../../services/entities/impl/blfApi/schemas/block';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';

type Props = {
  ranchName: string;
  blocks: Block[];
  blocksSelected: string[];
  onChange: (blockIds: string[]) => void;
};

export const BlockMultiSelectItem = ({
  ranchName,
  blocks,
  blocksSelected,
  onChange,
}: Props) => {
  const { t } = useTranslation();
  const options = useMemo(
    () =>
      blocks?.map((block) => ({
        label: block.name,
        value: block.id,
      })) || [],
    [blocks]
  );

  return (
    <BaseControlItem label={ranchName}>
      <SelectMultiple
        variant='minimal'
        disabled={blocks.length === 0}
        options={options}
        value={blocksSelected}
        onChange={(value) => onChange(value as string[])}
        selectAllOption={{ label: t('All Blocks') }}
      />
    </BaseControlItem>
  );
};
